<template>
  <div class="user-notifications">
    <user-notifications-dialog :type="dialogType" :item-id="dialogItemId" @closed="toggleDialog" v-if="dialogActive" />
  </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import UserNotificationsDialog from './UserNotificationsDialog'
  import { getDateLocale } from 'i18n'

  export default {
    name: 'UserNotifications',
    components: {
      UserNotificationsDialog
    },
    data: () => ({
      dialogActive: false,
      dialogType: null,
      dialogItemId: null
    }),
    computed: {
      ...mapGetters('auth', ['userId']),
      ...mapGetters('userNotifications', ['updatesCount']),
      ...mapState('userNotifications', ['updates']),
      updateStore () {
        return this.$firebase.collection('updates')
      },
      buttonClasses () {
        return {
          'is-active': this.dialogActive
        }
      }
    },
    watch: {
      userId: {
        immediate: true,
        handler (value) {
          if (value) {
            const checkIsMounted = window.setInterval(() => {
              if (this._isMounted) {
                this.subscribeToBroadcastNotifications()
                window.clearInterval(checkIsMounted)
              }
            }, 500)
          }
        }
      }
    },
    methods: {
      ...mapMutations('userNotifications', {
        setUpdates: 'SET_UPDATES',
        setReadUpdates: 'SET_READ_UPDATES'
      }),
      togglePanel () {
        this.dialogActive = false
      },
      toggleDialog () {
        document.getElementById('header-notifications')?.focus()
        this.dialogActive = !this.dialogActive
      },
      openDialog ({ type, id }) {
        if (id != null) {
          this.dialogItemId = id
        } else {
          this.dialogItemId = null
        }

        this.dialogType = type
        this.dialogActive = true
      },
      closeDialog () {
        this.dialogType = null
        this.dialogItemId = null
        this.dialogActive = false
      },
      subscribeToBroadcastNotifications () {
        this.updateStore.doc(this.userId.toString()).onSnapshot(collection => {
          if (collection.exists) {
            this.setReadUpdates(Object.keys(collection.data()))
          }
        })

        this.updateStore
          .doc('broadcast')
          .collection(getDateLocale((this.$i18n && this.$i18n.locale) || 'pt-BR'))
          .orderBy('createdAt', 'desc')
          .onSnapshot(collection => {
            if (collection) {
              this.setUpdates(collection.docs)
            }
          })
      }
    },
    async mounted () {
      this.$event.on('open:user-notifications-dialog', this.openDialog)
      this.$event.on('close:user-notifications-dialog', this.closeDialog)
    },
    beforeDestroy () {
      this.$event.off('open:user-notifications-dialog', this.openDialog)
      this.$event.off('close:user-notifications-dialog', this.closeDialog)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications {
    margin: 0 10px 0 20px;
    position: relative;
    z-index: 100;
  }

  .user-notifications-button {
    @include clear-button;
    position: relative;

    &:hover {
      svg {
        transform: scale(1.1);
      }
    }

    &.is-active {
      svg {
        transform: rotate(-15deg);
      }
    }

    svg {
      width: 22px;
      height: 22px;
      transition: transform .2s $transition-default;
      fill: #fff;
    }
  }

  .user-notifications-count {
    padding: 0 4px;
    position: absolute;
    top: 2px;
    right: -6px;
    background-color: $color-blue;
    border-radius: 3px;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
  }
</style>
